(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { gql as R, useQuery as ge, useLazyQuery as Be, useMutation as F, isApolloError as ke, useApolloClient as $e } from "@apollo/client";
import { getOperationName as Q } from "@apollo/client/utilities";
import { jsx as s, jsxs as h, Fragment as Y } from "react/jsx-runtime";
import { Icon as j, FlexBox as b, Text as O, List as se, Banner as me, Button as v, Modal as Le, ModalHead as Fe, ModalBody as Ue, ModalFoot as Ge, Spinner as fe, Tag as He, FormField as ae, FieldWrapper as z, Tooltip as pe, Badge as ce, FieldText as de } from "@dixa/lib-shared-habla";
import { colors as P } from "@dixa/lib-shared-tokens";
import { useState as u, useEffect as M, createContext as he, useContext as Ce, createElement as q, useCallback as L } from "react";
import { FormProvider as qe, useController as Qe } from "react-hook-form";
import ye from "moment";
import { useInterval as ze } from "react-use";
import Ke from "lodash/lowerCase";
import Ve from "lodash/upperFirst";
import { HookFormText as Je } from "lib-shared-hook-form";
import Ye from "classnames";
import { MockedProvider as Ze } from "@apollo/client/testing";
import { render as je } from "@testing-library/react";
const X = R`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, we = R`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
    $renderConditions: [Management_JSONObject!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
        renderConditions: $renderConditions
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, Ee = R`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
    $renderConditions: [Management_JSONObject!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
        renderConditions: $renderConditions
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, be = R`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, an = (e, t) => function(n, o) {
  return ge(n, {
    ...o,
    context: {
      operationName: Q(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, cn = (e, t) => function(n, o) {
  return Be(n, {
    ...o,
    context: {
      operationName: Q(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, dn = (e, t, n) => function(o, r) {
  return n.query({
    query: o,
    variables: r,
    context: {
      operationName: Q(o),
      widgetId: e,
      widgetType: t
    }
  });
}, ln = (e, t) => function(n, o) {
  return F(n, {
    ...o,
    context: {
      operationName: Q(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, Xe = ({
  error: e
}) => e.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", un = ({
  errors: e
}) => e.some((t) => Xe({ error: t })), et = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", gn = ({
  errors: e
}) => e.some((t) => et({ error: t })), tt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", mn = ({
  errors: e
}) => e.some((t) => tt({ error: t })), nt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", fn = ({
  errors: e
}) => e.some((t) => nt({ error: t })), ot = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", pn = ({
  errors: e
}) => e.some((t) => ot({ error: t })), rt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", hn = ({
  errors: e
}) => e.some((t) => rt({ error: t })), it = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", Cn = ({
  errors: e
}) => e.some((t) => it({ error: t })), st = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", yn = ({
  errors: e
}) => e.some((t) => st({ error: t })), at = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", wn = ({
  errors: e
}) => e.some((t) => at({ error: t })), ct = ({
  error: e
}) => e.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", dt = ({
  errors: e
}) => e.some((t) => ct({ error: t })), lt = (e) => {
  const { delay: t = 2e3 } = e || {}, [n, o] = u(!1);
  return M(() => {
    const i = n ? window.setTimeout(() => o(!1), t) : void 0;
    return () => window.clearTimeout(i);
  }, [t, n]), { isCopied: n, copy: (i) => {
    navigator.clipboard.writeText(i), o(!0);
  } };
}, ut = "_errorWrapper_171rr_1", gt = "_copyIcon_171rr_5", V = {
  errorWrapper: ut,
  copyIcon: gt
}, mt = ({
  error: e,
  retry: t,
  isMisconfigured: n = !1,
  hideCopyButton: o = !1
}) => {
  const i = e && ke(e) && e?.graphQLErrors?.length > 0, { isCopied: a, copy: c } = lt(), g = /* @__PURE__ */ s(
    j,
    {
      color: P.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (n || i && dt({
    errors: e.graphQLErrors
  }))
    return /* @__PURE__ */ h(b, { margin: "0 0 100", padding: "200", className: V.errorWrapper, children: [
      /* @__PURE__ */ s(b, { margin: "0 300 0 0", alignItems: "center", children: g }),
      /* @__PURE__ */ s(O.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!i)
    return /* @__PURE__ */ s(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ s(
      se.Item,
      {
        contentLeft: g,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const p = e?.graphQLErrors || [];
  return /* @__PURE__ */ h(
    b,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: V.errorWrapper,
      children: [
        p.map((l, m) => {
          const d = l?.extensions?.integration, C = d?.message || e?.message || "No error message available", y = d?.responseBody && JSON.parse(d?.responseBody), A = y?.errorMessages || [], N = y?.warningMessages || [], E = [...A, ...N].join(" ");
          return /* @__PURE__ */ s(
            se.Item,
            {
              title: C,
              titleSecondary: E,
              contentLeft: g
            },
            m
          );
        }),
        !o && /* @__PURE__ */ h(b, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ s(
            me,
            {
              variant: "info",
              description: /* @__PURE__ */ s(O.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ h(b, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            t && /* @__PURE__ */ s(v, { variant: "secondary", icon: "sync", onClick: () => t(), children: "Retry" }),
            /* @__PURE__ */ s(
              v,
              {
                variant: "secondary",
                icon: a ? "done" : "copy",
                onClick: () => c(JSON.stringify(p, null, 2)),
                className: V.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
}, ft = ({
  headline: e,
  text: t,
  children: n,
  onConfirm: o,
  onCancel: r,
  confirmLabel: i,
  cancelLabel: a = "Cancel",
  confirmVariant: c = "primary",
  cancelVariant: g = "secondary",
  isOpen: p,
  setIsOpen: l,
  showOnClose: m = !1
}) => /* @__PURE__ */ h(
  Le,
  {
    isOpen: p,
    onClose: () => {
      r && r(), l(!1);
    },
    children: [
      /* @__PURE__ */ s(
        Fe,
        {
          title: e,
          onClose: m ? r : void 0
        }
      ),
      /* @__PURE__ */ h(Ue, { children: [
        t && /* @__PURE__ */ s("div", { style: { width: "600px" }, children: t }),
        n
      ] }),
      /* @__PURE__ */ s(
        Ge,
        {
          confirmOnClick: o ? () => {
            o(), l(!1);
          } : void 0,
          cancelOnClick: () => {
            r && r(), l(!1);
          },
          confirmName: i,
          cancelName: a,
          confirmProps: { variant: c },
          cancelProps: { variant: g }
        }
      )
    ]
  }
), ee = "The configuration of the integration is not correct. Please check the settings.", En = ({
  cause: e
}) => /* @__PURE__ */ s(b, { margin: "0 0 400", children: /* @__PURE__ */ s(
  me,
  {
    variant: "fail",
    headline: "This integration is misconfigured",
    description: /* @__PURE__ */ h(b, { gap: "300", flexDirection: "column", children: [
      /* @__PURE__ */ s(O.Paragraph, { children: e || ee }),
      /* @__PURE__ */ h(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ s(O.Heading, { variant: "heading-3", children: "Additional information" }),
        /* @__PURE__ */ s(O.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
      ] })
    ] })
  }
) }), bn = ({
  form: e,
  integrationId: t,
  onValidSubmit: n,
  error: o,
  onRetry: r,
  isLoading: i,
  isWidgetUnknown: a,
  children: c
}) => o ? /* @__PURE__ */ s(mt, { error: o, retry: r }) : i ? /* @__PURE__ */ s(fe, { "data-testid": "widget-settings-loading" }) : a ? /* @__PURE__ */ h(O.Paragraph, { children: [
  "A widget with the id ",
  /* @__PURE__ */ s(He, { children: t }),
  " does not exist."
] }) : /* @__PURE__ */ s(qe, { ...e, children: /* @__PURE__ */ s(
  "form",
  {
    noValidate: !0,
    tabIndex: -1,
    "data-testid": `widget-settings-form-${t ?? "create-new"}`,
    onSubmit: e.handleSubmit(n),
    children: c
  }
) });
function An(e, t = !0) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return t && console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const Nn = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, Mn = (e) => {
  const t = Ke(e);
  return t.length === 0 ? e : Ve(t);
}, Ae = "DD MMM YYYY @ HH:mm";
function pt(e, t) {
  return e == null ? t : typeof e == "boolean" ? e : e === "true";
}
function ht(e, t) {
  return e == null ? t : String(e);
}
function Sn(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const On = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Tn = (e) => {
  if (!e?.trim())
    return "Please add a valid subdomain";
  const n = ["https://", "http://"].find(
    (i) => e.startsWith(i)
  ), o = n ? `Please remove the protocol \`${n}\` from the hostname` : "", r = e.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (o && r)
    return `Please remove the protocol \`${n}\` and the trailing \`/\` from the hostname`;
  if (o)
    return o;
  if (r)
    return r;
};
function Ct(e) {
  const t = e.split(".")[1];
  if (!t)
    throw Error("Invalid token");
  const n = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(n).toString());
  } catch (o) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${o}`
    );
  }
}
const te = ["==", "!="], yt = [
  ...te
], wt = [
  ...te,
  "begins_with",
  "ends_with",
  "matches"
  // regex - https://github.com/dixahq/elevion/blob/f07a08fb5b0229925b1e42a2efad12870e3d46e1/elevion/src/test/scala/com/elevio/elevion/parser/ElevionParserTest.scala#L25
], Et = [
  "contains_one",
  "contains_all",
  "is_empty"
], bt = ["between", "not_between"], Ne = [
  ...te,
  ">",
  "<"
], Me = [
  "before",
  "after",
  ...Ne
], At = Me;
[
  // remove duplicates using Set
  .../* @__PURE__ */ new Set([
    ...yt,
    ...wt,
    ...Et,
    ...bt,
    ...Me,
    ...At,
    ...Ne
  ])
];
const Nt = "custom__";
var Z = /* @__PURE__ */ ((e) => (e.Queue = "system__queue", e.Tags = "system__tags", e))(Z || {});
const Mt = (e) => e === Z.Queue ? "Queue" : e === Z.Tags ? "Tags" : e.startsWith(Nt) ? "Custom attribute" : e, Se = (e, t) => {
  if ("logicalOp" in e) {
    e.nodes.forEach((n) => Se(n, t));
    return;
  }
  t.add(Mt(e.field));
}, St = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((n) => Se(n, t)), [...t].sort().join(", ");
}, le = (e, t, n, o) => {
  const r = n.length > 0, i = St(n);
  if (t) {
    r && e("settings:condition:created", { conditionType: i });
    return;
  }
  r ? e("settings:condition:updated", { conditionType: i }) : o && e("settings:condition:deleted", {});
}, Oe = he(null);
function Ot() {
  const e = Ce(Oe);
  if (e === null)
    throw Error(
      "useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider"
    );
  return e;
}
function Tt() {
  return {
    isInboundOAuth: !1,
    setIsInboundOAuth: () => {
    },
    hasTriggeredAuthorization: !1,
    setHasTriggeredAuthorization: () => {
    }
  };
}
const Te = he(null), Dt = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Te.Provider
);
function xt() {
  const e = Ce(Te);
  if (e === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return e;
}
function Dn() {
  window._partner = {
    events: { emit: () => {
    } }
  };
}
const Pt = {
  useMutation: F,
  // Returns an Apollo-shaped result so settings components that read a
  // per-widget query via `useWidgetContext()` (e.g. Klaviyo's subscribe-list
  // selector) can destructure it. Tests that need real query data wrap the
  // component in their own provider.
  useQuery: () => ({ data: void 0, loading: !1, error: void 0 }),
  useLazyQuery: () => [() => {
  }, { loading: !1 }],
  executeQuery: () => {
  },
  showNotification: () => {
  },
  showModal: () => {
  }
}, It = {
  baseUrl: "http://localhost/graphql"
};
function xn(e, { mocks: t = [], overrides: n = {} } = {}) {
  const o = vi.fn(), r = vi.fn(), a = { ...{
    configuration: It,
    handleRedirect: o,
    showNotification: r
  }, ...n };
  return { ...je(
    q(
      Ze,
      { mocks: t },
      q(
        Oe.Provider,
        { value: Tt() },
        q(
          Dt,
          { value: Pt },
          q(e, a)
        )
      )
    )
  ), handleRedirect: o, showNotification: r };
}
function Pn({
  id: e,
  configuration: t
}) {
  const n = t?.settings ?? [];
  return {
    request: {
      query: X,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          widgetConfigurations: [
            {
              id: e,
              type: t?.type ?? "UNKNOWN",
              name: t?.name ?? "Test widget",
              enabled: t?.enabled ?? !0,
              misconfigured: t?.misconfigured ?? !1,
              misconfigurationCause: t?.misconfigurationCause ?? null,
              additionalProperties: t?.additionalProperties ?? null,
              renderConditions: t?.renderConditions ?? [],
              settings: n
            }
          ]
        }
      }
    }
  };
}
function In({
  variables: e,
  result: t
}) {
  const n = {
    ...e,
    renderConditions: e.renderConditions ?? []
  };
  return {
    request: {
      query: Ee,
      variables: n
    },
    result: {
      data: {
        Management: {
          createWidgetConfiguration: {
            id: t?.id ?? "new-id",
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            renderConditions: t?.renderConditions ?? n.renderConditions,
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function vn({
  variables: e,
  result: t
}) {
  return {
    request: {
      query: we,
      variables: e
    },
    result: {
      data: {
        Management: {
          updateWidgetConfiguration: {
            id: e.id,
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled ?? !0,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            renderConditions: t?.renderConditions ?? e.renderConditions ?? [],
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function _n({
  id: e
}) {
  return {
    request: {
      query: be,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          deleteWidgetConfiguration: { id: e }
        }
      }
    }
  };
}
function vt(e, t) {
  const n = {};
  for (const o of t) {
    const i = e.find((a) => a.key === o.key)?.value;
    o.secret && i === void 0 || (o.type === "boolean" ? n[o.key] = pt(i, o.defaultValue) : n[o.key] = ht(i, o.defaultValue));
  }
  return n;
}
function _t(e, t) {
  return t.filter((n) => e[n.key] !== void 0).map((n) => ({
    key: n.key,
    value: String(e[n.key]),
    secret: n.secret
  }));
}
function Wn(e) {
  return Object.fromEntries(
    e.map((t) => [t.key, t.label])
  );
}
async function Rn(e, {
  fieldDefinitions: t,
  isCreationMode: n,
  create: o,
  update: r,
  renderConditions: i
}) {
  const a = _t(e, t), c = {
    name: e.name,
    enabled: e.enabled,
    settings: a,
    ...i !== void 0 && { renderConditions: i }
  };
  n ? await o(c) : await r(c);
}
function Wt(e) {
  const { user_id: t, iss: n } = Ct(e);
  return {
    "x-integration-user-id": t,
    "x-integration-organization-id": n
  };
}
function Rt(e) {
  return e.startsWith("http://localhost");
}
function ne() {
  return { track: (t, n) => window._partner.events.emit(t, n) };
}
const Bt = (e) => {
  switch (e) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: P.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: P.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: P.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: P.red[200],
        tooltip: "Connection timeout"
      };
    default:
      return {
        icon: "exclamation-circle-filled",
        color: P.neutral[500],
        tooltip: "Not connected"
      };
  }
}, Bn = ({
  configuration: e,
  integrationId: t,
  integrationType: n,
  label: o
}) => {
  const [r, i] = u("CONNECTING"), [a, c] = u(""), [g, p] = u(null), { track: l } = ne(), { icon: m, color: d, tooltip: C } = Bt(r), y = 3, A = 15, N = 2e3, [E, _] = u({}), [S, f] = u(0), [D, U] = u(N), [T, I] = u(!1), [W, B] = u(y), {
    isInboundOAuth: De,
    setIsInboundOAuth: xe,
    hasTriggeredAuthorization: Pe,
    setHasTriggeredAuthorization: Ie
  } = Ot(), { baseUrl: G } = e, ve = `${G}/auth/connect/${n.toLowerCase()}/${t}`, _e = `${G}/auth/status/${n.toLowerCase()}/${t}`, oe = r === "CONNECTING", re = (w) => Object.keys(w).length === 0, K = () => {
    I(!1), f(0);
  };
  M(() => {
    const w = localStorage.getItem("authData");
    if (w) {
      const x = JSON.parse(w ?? "{}").access_token;
      _({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${x}`,
          ...Rt(G) && Wt(x)
        }
      });
    }
  }, [G]), M(() => {
    re(E) || I(!0);
  }, [E]);
  const We = () => {
    B(A), fetch(_e, { ...E }).then((w) => w.json()).then(({ data: w }) => {
      const { status: k, createdAt: x, createdByName: $ } = w;
      switch (k) {
        case "CONNECTING":
          i("CONNECTING");
          break;
        case "CONNECTED": {
          if (l("settings:view:oauth:succeeded", {
            widgetId: t,
            widgetType: n
          }), i("CONNECTED"), x && $) {
            const H = new Date(x);
            isNaN(H.getTime()) || p(H), c($);
          }
          K();
          break;
        }
        case "NOT_CONNECTED":
        case "CONNECTION_FAILED":
          i(k), K();
      }
    }).catch((w) => {
      console.warn(
        `Fetching OAuth status failed for ${n} ${t}`,
        w
      ), i("CONNECTION_FAILED");
    });
  };
  ze(
    () => {
      S >= W ? (i("CONNECTION_TIMEOUT"), K()) : (We(), f(S + 1));
    },
    T ? D : null
  );
  const ie = () => {
    l("settings:view:oauth:started", {
      widgetId: t,
      widgetType: n
    }), fetch(ve, { ...E }).then((w) => w.json()).then(({ data: w }) => {
      const { url: k } = w, x = 620, $ = 800, H = window.innerWidth / 2 - x / 2, Re = window.innerHeight / 2 - $ / 2;
      i("CONNECTING"), I(!0), window.open(
        k,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${x},
						height=${$},
						left=${H},
						top=${Re}`
      );
    }).catch((w) => {
      console.warn(
        `Fetching OAuth connection failed for ${n} ${t}`,
        w
      ), i("CONNECTION_FAILED");
    });
  };
  return M(() => {
    De && !Pe && !re(E) && (Ie(!0), xe(!1), ie());
  }, [E]), /* @__PURE__ */ h(Y, { children: [
    /* @__PURE__ */ s(ae, { span: 3, children: /* @__PURE__ */ s(
      z,
      {
        label: o,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ h(b, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ s(
            v,
            {
              icon: "key",
              variant: "secondary",
              onClick: ie,
              disabled: oe,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ s(pe, { content: C, children: oe ? /* @__PURE__ */ s(fe, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ h(b, { alignItems: "center", gap: "200", children: [
            /* @__PURE__ */ s(
              j,
              {
                "data-testid": "oauth-button-status-icon",
                name: m,
                color: d
              }
            ),
            r === "CONNECTED" && a && g && /* @__PURE__ */ h(O.Paragraph, { variant: "4", subdued: !0, children: [
              "Authorized by ",
              a,
              " at",
              " ",
              ye(g).format(Ae)
            ] })
          ] }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ s(ae, { span: 3 })
  ] });
}, kn = (e) => {
  if (e == null)
    return null;
  if (Array.isArray(e))
    return /* @__PURE__ */ s(O.Paragraph, { variant: "5", color: "secondary", align: "right", children: e.join(", ") });
  if (typeof e == "boolean" || e === "true" || e === "false") {
    const o = e === "true" || e === !0;
    return /* @__PURE__ */ s(
      j,
      {
        name: o ? "check-circle-filled" : "close-circle-filled",
        color: o ? P.green[500] : P.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${o ? "true" : "false"}`
      }
    );
  }
  if (typeof e == "number" || /^\d*\.?\d+$/.test(e))
    return /* @__PURE__ */ s(ce, { variant: "success", size: "small", children: e });
  if (e.startsWith("days_ago: ")) {
    const o = e.replace("days_ago: ", ""), r = o.startsWith("-"), i = o === "0", a = r ? `${o.replace("-", "")} days ago` : `in ${o} days`;
    return /* @__PURE__ */ s(O.Paragraph, { variant: "5", color: "secondary", children: i ? "today" : a });
  }
  const n = ye(e);
  return n.isValid() ? /* @__PURE__ */ s(O.Paragraph, { variant: "5", color: "secondary", children: n.format(Ae) }) : /* @__PURE__ */ s(ce, { variant: "info", size: "small", children: e });
}, $n = (e) => {
  const { isCreationMode: t = !1, label: n, helpIcon: o, name: r } = e, [i, a] = u(t);
  if (!i) {
    const c = typeof n == "string" ? n : "";
    return /* @__PURE__ */ s(z, { label: n, helpIcon: o, children: /* @__PURE__ */ h(
      v,
      {
        "data-testid": `secret-field-button-${r}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => a(!0),
        children: [
          "Update ",
          c
        ]
      }
    ) });
  }
  return /* @__PURE__ */ s(
    kt,
    {
      ...e,
      isCreationMode: t,
      onClose: () => a(!1)
    }
  );
}, kt = (e) => {
  const { isCreationMode: t, componentProps: n, onClose: o } = e, r = {
    ...n,
    prefix: t ? n?.prefix : {
      type: "button",
      button: { icon: "close", onClick: o }
    }
  };
  return /* @__PURE__ */ s(
    Je,
    {
      ...e,
      componentProps: r,
      shouldUnregister: !0
    }
  );
}, $t = "_wrapper_1lmim_1", Lt = "_wrapperBox_1lmim_4", Ft = "_wrapperBoxErrorBorder_1lmim_9", J = {
  wrapper: $t,
  wrapperBox: Lt,
  wrapperBoxErrorBorder: Ft
}, ue = (e, t) => e !== "" && t !== "" ? window.btoa(`${e}:${t}`) : "", Ln = (e) => {
  const { isCreationMode: t = !1, label: n, name: o } = e, [r, i] = u(t);
  if (!r) {
    const a = typeof n == "string" ? n : "";
    return /* @__PURE__ */ s(z, { label: n, children: /* @__PURE__ */ h(
      v,
      {
        "data-testid": `secret-field-button-${o}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => i(!0),
        children: [
          "Update ",
          a
        ]
      }
    ) });
  }
  return /* @__PURE__ */ s(
    Ut,
    {
      ...e,
      isCreationMode: t,
      onClose: () => i(!1)
    }
  );
}, Ut = (e) => {
  const {
    name: t,
    control: n,
    label: o,
    rules: r,
    isCreationMode: i,
    usernameLabel: a,
    passwordLabel: c,
    usernamePlaceholder: g,
    passwordPlaceholder: p,
    onClose: l
  } = e, { field: m, fieldState: d } = Qe({
    name: t,
    control: n,
    rules: r,
    shouldUnregister: !0
  }), [C, y] = u(""), [A, N] = u(""), E = (f) => {
    y(f), m.onChange(ue(f, A));
  }, _ = (f) => {
    N(f), m.onChange(ue(C, f));
  }, S = !!r?.required;
  return /* @__PURE__ */ s(
    z,
    {
      label: o,
      required: S,
      meta: {
        touched: d.isTouched,
        error: d.error?.message
      },
      className: J.wrapper,
      children: /* @__PURE__ */ h(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: Ye(J.wrapperBox, {
            [J.wrapperBoxErrorBorder]: !!d.error
          }),
          children: [
            /* @__PURE__ */ s(
              de,
              {
                noAlert: !0,
                required: S,
                label: a,
                placeholder: g,
                input: {
                  name: t,
                  value: C,
                  onChange: (f) => E(f?.target.value ?? ""),
                  onBlur: m.onBlur
                },
                ...!i && {
                  prefix: {
                    type: "button",
                    button: { icon: "close", onClick: l }
                  }
                }
              }
            ),
            /* @__PURE__ */ s(
              de,
              {
                noAlert: !0,
                required: S,
                label: c,
                placeholder: p,
                input: {
                  name: t,
                  value: A,
                  onChange: (f) => _(f?.target.value ?? ""),
                  onBlur: m.onBlur
                },
                ...!i && {
                  prefix: {
                    type: "button",
                    button: { icon: "close", onClick: l }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
}, Gt = {
  submit: "Submit",
  delete: "Delete",
  confirmDelete: "Yes",
  cancelDelete: "No"
}, Fn = ({
  integrationType: e,
  integrationId: t,
  widgetName: n,
  isCreationMode: o,
  isSubmitting: r,
  automationCouplingState: i,
  onConfirmDelete: a,
  labels: c,
  deleteConfirmationBody: g,
  confirmDeleteVariant: p = "primary"
}) => {
  const { track: l } = ne(), [m, d] = u(!1), C = { ...Gt, ...c }, y = !i || !i.isCoupled, A = () => {
    t && l("settings:view:delete:requested", {
      widgetId: t,
      widgetType: e
    }), d(!0);
  }, N = () => {
    t && l("settings:view:delete:canceled", {
      widgetId: t,
      widgetType: e
    });
  };
  return /* @__PURE__ */ h(Y, { children: [
    /* @__PURE__ */ h(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ s(v, { type: "submit", isLoading: r, disabled: r, children: C.submit }),
      !o && /* @__PURE__ */ s(
        pe,
        {
          content: "The widget is used in automations",
          disabled: y,
          children: /* @__PURE__ */ s(
            v,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              type: "button",
              onClick: A,
              disabled: !y,
              isLoading: i?.isLoading,
              children: C.delete
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ s(
      ft,
      {
        isOpen: m,
        setIsOpen: d,
        confirmVariant: p,
        confirmLabel: C.confirmDelete,
        cancelLabel: C.cancelDelete,
        onCancel: N,
        onConfirm: a,
        children: /* @__PURE__ */ s(b, { children: g ?? /* @__PURE__ */ h(Y, { children: [
          "Are you sure you want to delete the ",
          e,
          ' integration "',
          n,
          '"?'
        ] }) })
      }
    )
  ] });
}, Ht = R`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, qt = R`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function Un(e) {
  const { useQuery: t, useMutation: n } = xt(), [o, r] = u(), [i, a] = u(), [c, g] = u(!1), {
    loading: p,
    data: l,
    error: m
  } = t(
    Ht,
    {
      skip: !e,
      variables: {
        conversationId: e?.toString()
      }
    }
  ), [d, { loading: C, error: y }] = n(
    qt
  ), A = async (N, E) => await d({
    variables: {
      conversationId: (E ?? e)?.toString(),
      data: N
    }
  }).then(
    ({ data: S }) => r(S?.Storage?.storeWidgetData?.data ?? {})
  );
  return M(() => {
    !p && l && r(l?.Storage?.widgetData ?? {});
  }, [l, p]), M(() => m && a(m), [m]), M(() => g(p), [p]), M(() => y && a(y), [y]), M(() => g(C), [C]), {
    data: o,
    loading: c,
    store: A,
    error: i
  };
}
const Gn = ({
  integrationId: e,
  integrationType: t,
  handleRedirect: n,
  showNotification: o
}) => {
  const { track: r } = ne(), [i, a] = u(!1), [c, g] = u(), [p, l] = u(null), m = L(
    (f) => (D) => {
      g(D), a(!1), o({
        title: "Something went wrong",
        text: `The ${f} of the widget was not successful.`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    [o]
  ), [d] = F(Ee, {
    onError: m("creation")
  }), [C] = F(we, {
    onError: m("update")
  }), [y] = F(be, {
    onError: m("deletion")
  }), A = $e(), N = L(() => e ? !!A.readQuery({
    query: X,
    variables: { id: e }
  })?.Management?.widgetConfigurations?.[0]?.renderConditions?.length : !1, [A, e]), E = L(
    async ({
      name: f,
      enabled: D,
      settings: U,
      renderConditions: T = []
    }) => {
      r("settings:create:submitted", { widgetType: t }), a(!0), g(void 0);
      const { data: I } = await d({
        variables: {
          type: t,
          name: f,
          enabled: D,
          settings: U,
          renderConditions: T
        }
      });
      a(!1);
      const W = I?.Management?.createWidgetConfiguration;
      if (!W) {
        o({
          title: "Something went wrong",
          text: "The creation of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      le(r, !0, T, !1), o({
        title: "Creating was successful",
        text: "Creating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), n(W.id);
    },
    [d, n, t, o, r]
  ), _ = L(
    async ({
      name: f,
      enabled: D,
      settings: U,
      renderConditions: T
    }) => {
      if (!e)
        return;
      r("settings:view:change:submitted", {
        widgetId: e,
        widgetType: t
      });
      const I = N();
      a(!0), g(void 0);
      const { data: W } = await C({
        variables: {
          id: e,
          name: f,
          enabled: D,
          settings: U,
          ...T !== void 0 && { renderConditions: T }
        }
      });
      a(!1);
      const B = W?.Management?.updateWidgetConfiguration;
      if (!B) {
        o({
          title: "Something went wrong",
          text: "The update of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      B.misconfigured ? l(
        B.misconfigurationCause ?? ee
      ) : l(null), T && le(
        r,
        !1,
        T,
        I
      ), o({
        title: "Updating was successful",
        text: "Updating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    },
    [
      e,
      t,
      N,
      o,
      r,
      C
    ]
  ), S = L(async () => {
    if (!e)
      return;
    r("settings:view:delete:confirmed", {
      widgetId: e,
      widgetType: t
    }), a(!0), g(void 0);
    const { data: f } = await y({
      variables: { id: e }
    });
    a(!1), f?.Management?.deleteWidgetConfiguration && (n(), o({
      title: "Deletion was successful",
      text: "The deletion of the widget was successful.",
      icon: "check-circle-filled",
      severity: "success"
    }));
  }, [
    y,
    n,
    e,
    t,
    o,
    r
  ]);
  return {
    create: E,
    update: _,
    remove: S,
    isLoading: i,
    error: c,
    misconfigurationCause: p,
    setMisconfigurationCause: l
  };
};
function Hn({
  integrationId: e,
  fieldDefinitions: t,
  form: n,
  onMisconfigured: o
}) {
  const [r, i] = u(!1), [a, c] = u(), { loading: g, error: p, refetch: l } = ge(X, {
    variables: { id: e },
    skip: !e,
    onCompleted: (m) => {
      const d = m?.Management?.widgetConfigurations?.[0];
      if (!d) {
        i(!0), c(void 0);
        return;
      }
      i(!1), c(d), n.reset({
        ...vt(d.settings ?? [], t),
        enabled: !!d.enabled,
        name: d.name
      }), d.misconfigured && o?.(
        d.misconfigurationCause ?? ee
      );
    }
  });
  return M(() => {
    i(!1), c(void 0);
  }, [e]), {
    isLoading: g,
    error: p,
    isWidgetUnknown: r,
    refetch: l,
    widgetConfiguration: a
  };
}
function qn({
  integrationId: e,
  widgetConfiguration: t,
  renderConditionsEditor: n
}) {
  const o = !e, [r, i] = u(o ? [] : null);
  return M(() => {
    i(o ? [] : null);
  }, [e, o]), M(() => {
    t && r === null && i(t.renderConditions ?? []);
  }, [t, r]), {
    renderConditions: r,
    setRenderConditions: i,
    renderConditionsForSubmit: !!n && r !== null && r !== null ? r : void 0
  };
}
export {
  mt as DisplayErrors,
  Oe as InboundOAuthContext,
  ft as IntegrationModal,
  En as MisconfigurationBanner,
  Bn as OAuthSettings,
  Ln as PartnerHookFormBasicAuth,
  $n as PartnerHookFormSecretText,
  bn as PartnerSettingsWrapper,
  Dt as WidgetContextProvider,
  Fn as WidgetSettingsFormFooter,
  Nn as capitalizeFirstCharacter,
  On as countryCodes,
  Tt as createMockInboundOAuthContextOptions,
  In as createWidgetConfigurationCreateMock,
  _n as createWidgetConfigurationDeleteMock,
  Ee as createWidgetConfigurationMutation,
  Pn as createWidgetConfigurationQueryMock,
  vn as createWidgetConfigurationUpdateMock,
  An as deepClone,
  Ae as defaultDateFormat,
  ee as defaultMisconfigurationCause,
  It as defaultPartnerSettingsConfiguration,
  Pt as defaultWidgetContextValue,
  be as deleteWidgetConfigurationMutation,
  kn as displayAttributeValue,
  _t as formValuesToSettings,
  St as getConditionType,
  Bt as getConnectionStatusValues,
  Sn as getCountryNameFromCountryCode,
  Wt as getPartnerDevApiHeaders,
  X as getWidgetConfigurationByIdQuery,
  Rn as handleWidgetSubmit,
  un as hasDixaHeaderCheckError,
  gn as hasDownstreamApiAuthorizationError,
  Cn as hasDownstreamApiBadRequestError,
  hn as hasDownstreamApiConflictError,
  yn as hasDownstreamApiForbiddenError,
  pn as hasDownstreamApiNotFoundError,
  mn as hasDownstreamApiPermissionError,
  fn as hasDownstreamApiServiceUnavailableError,
  wn as hasDownstreamApiTooManyRequestsError,
  dt as hasWidgetMisconfiguredError,
  Mn as humanizeKey,
  Xe as isDixaHeaderCheckError,
  et as isDownstreamApiAuthorizationError,
  it as isDownstreamApiBadRequestError,
  rt as isDownstreamApiConflictError,
  st as isDownstreamApiForbiddenError,
  ot as isDownstreamApiNotFoundError,
  tt as isDownstreamApiPermissionError,
  nt as isDownstreamApiServiceUnavailableError,
  at as isDownstreamApiTooManyRequestsError,
  Rt as isRunningLocalPartnerApi,
  ct as isWidgetMisconfiguredError,
  dn as makeExecuteQuery,
  cn as makeUseLazyQuery,
  ln as makeUseMutation,
  an as makeUseQuery,
  Wn as mapLabels,
  Ct as parseAccessToken,
  pt as parseBoolean,
  ht as parseString,
  xn as renderPartnerSettings,
  vt as settingsToFormValues,
  Dn as stubPartnerEventsBusForTests,
  le as trackRenderConditionsSaved,
  we as updateWidgetConfigurationMutation,
  lt as useCopyWithDelay,
  Un as useData,
  Ot as useInboundOAuthContext,
  qn as useRenderConditions,
  ne as useTracking,
  xt as useWidgetContext,
  Gn as useWidgetSettingsMutations,
  Hn as useWidgetSettingsQuery,
  Tn as validateApiHostName
};
